import EmailCollector from './EmailCollector.vue'

export default EmailCollector
